import script from "./TextGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextGallery.vue?vue&type=script&setup=true&lang=ts"

import "./TextGallery.vue?vue&type=style&index=0&id=739370d9&lang=scss"

const __exports__ = script;

export default __exports__